// @flow

import { findRecipientInContacts, getHasSentToContact } from './contact-utils'

/**
 * Determines if the sender/requestor is confident that they entered the correct recipient
 * @param {boolean} isUnilateral - whether the recipient is unilateral or not
 * @param {boolean} hasSentToRecipient - whether the recipient has been sent to before or not
 * @returns {boolean} whether the sender/requestor is confident that they entered the correct recipient or not
 */
export function getIsConfidentInRecipient(
  isUnilateral: boolean,
  hasSentToRecipient: boolean
) {
  return Boolean(!isUnilateral && hasSentToRecipient)
}

/**
 * Determine whether the recipient specified has been sent to before by checking contacts or
 * if contacts have not been hydrated yet asynchronously on the client then true. Consumers
 * should be aware that this could result in false-positives if called before client is hydrated
 * @param {string} recipient
 * @param {Array<FormattedContact>} contacts - formatted contact list
 * @param {boolean} hasFetchedContacts - whether contacts have been hydrated on client yet
 * @returns {boolean} whether or not recipient has been sent to previously
 */
export function getHasSentToRecipient(
  recipient: string,
  contacts: Array<FormattedContact>,
  hasFetchedContacts: boolean
) {
  if (!hasFetchedContacts) {
    return true
  }

  return getHasSentToContact(findRecipientInContacts(recipient, contacts))
}
